import SvgIcon from 'material-ui/SvgIcon';
import React from 'react';

const LocationIcon = (props) => (
  <SvgIcon {...props}>
    <g>
      <path fill="none" stroke={props.color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" strokeMiterlimit="10" d="
        M19,9c0-3.866-3.134-7-7-7S5,5.134,5,9c0,6,7,13,7,13S19,15,19,9z"/>
      
        <circle fill="none" stroke={props.color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" strokeMiterlimit="10" cx="12" cy="9" r="3"/>
    </g>
  </SvgIcon>
);

export default LocationIcon;



// WEBPACK FOOTER //
// ./src/icons/menu/LocationIcon.jsx